import { DataMode, DataOptions, DataProvider, DataResults } from '../../../types';

export class DataOptionsFactory {
  private provider?: DataProvider;
  private data?: DataResults;
  private dataMode: DataMode = DataMode.takeFromProvider;

  private constructor() {}

  static asProvider(provider?: DataProvider): DataOptionsFactory {
    const cls = new DataOptionsFactory();
    cls.provider = provider;
    cls.dataMode = DataMode.isProvider;
    return cls;
  }

  static withData(data: DataResults): DataOptionsFactory {
    const cls = new DataOptionsFactory();
    cls.dataMode = DataMode.isPresent;
    cls.data = data;
    return cls;
  }

  static asReceiver(): DataOptionsFactory {
    const cls = new DataOptionsFactory();
    cls.dataMode = DataMode.takeFromProvider;
    return cls;
  }

  _build(): DataOptions {
    return {
      mode: this.dataMode,
      providerInfo: this.provider,
      data: this.data,
    };
  }
}
